import { Link } from '@remix-run/react';
import useTranslation from '~/i18n/i18n';
import { useUser } from '~/lib/providers/user-provider';
import { Button } from '../ui/button';

interface ErrorProps {
  title?: string;
  subtitle?: string;
  description?: string;
}

const ErrorView = ({ title, subtitle, description }: ErrorProps) => {
  const { t } = useTranslation();
  const { user } = useUser();

  return (
    <div className="flex flex-col py-16 text-center">
      {title && (
        <h1 className="-mb-[2rem] font-special text-[10rem] font-bold tracking-wide text-destructive sm:-mb-[4rem] sm:text-[16rem]">
          {title}
        </h1>
      )}

      <div className="mb-12 max-w-md">
        {subtitle && <h2 className="text-xl font-semibold">{subtitle}</h2>}
        {description && (
          <p className="mt-2 text-justify text-xl">{description}</p>
        )}
      </div>

      <Link to={user ? '/dashboard' : '/'}>
        <Button variant="outline" size="lg" className="w-full sm:w-fit">
          {t('game.actions.returnToHomePage')}
        </Button>
      </Link>
    </div>
  );
};

export default ErrorView;
